import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { VenueModel } from './venue.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { VenueDailyPrice } from '@app/venues/shared/venue-daily-price.mode';
import { PagedEntities } from '@app/shared/abstract/paged-entities';

export type VenuePriceImportPreviewRow = {
  date: string;
  hire_price: number | null;
  minimum_spend: number | null;
  status: 'create' | 'update' | 'skip' | 'delete';
  previous_hire_price: number | null;
  previous_minimum_spend: number | null;
};

export type VenuePriceImportPreviewSummary = {
  total: number;
  create_count: number;
  update_count: number;
  skip_count: number;
  delete_count: number;
  date_range: {
    start: string | null;
    end: string | null;
  };
};

export type VenuePriceImportPreview = {
  summary: VenuePriceImportPreviewSummary;
  rows: VenuePriceImportPreviewRow[];
};

@Injectable({
  providedIn: 'root',
})
export class VenueService extends AbstractEntityService<VenueModel> {
  constructor(http: HttpClient) {
    super('/api/venues', http);
  }

  saveFormData(formData: FormData, venueId?: number | null): Observable<ResourceData<VenueModel>> {
    if (venueId) {
      return this.http.post<ResourceData<VenueModel>>(`${this.apiUrl}${this.basePath}/${venueId}`, formData);
    } else {
      return this.http.post<ResourceData<VenueModel>>(`${this.apiUrl}${this.basePath}`, formData);
    }
  }

  exportPricesCSV(venueId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}${this.basePath}/${venueId}/prices/export`, {
      responseType: 'blob',
    });
  }

  getAll(): Observable<{data: any[]}> {
    return this.http.get<{data: any[]}>(`${this.apiUrl}${this.basePath}/all`);
  }

  importPricesCSV(venueId: number, formData: FormData): Observable<any> {
    return this.http.post(`${this.apiUrl}${this.basePath}/${venueId}/prices/import`, formData);
  }

  previewPricesImport(venueId: number, formData: FormData): Observable<VenuePriceImportPreview> {
    return this.http.post<VenuePriceImportPreview>(`${this.apiUrl}${this.basePath}/${venueId}/prices/import/preview`, formData);
  }

  getVenueDailyPrices(venueId: number): Observable<ResourceData<VenueDailyPrice[]>> {
    return this.http.get<ResourceData<VenueDailyPrice[]>>(`${this.apiUrl}${this.basePath}/${venueId}/prices`);
  }

  getVenueDailyPriceForDate(venueId: number, date: string): Observable<ResourceData<VenueDailyPrice>> {
    return this.http.get<ResourceData<VenueDailyPrice>>(`${this.apiUrl}${this.basePath}/${venueId}/prices/${date}`);
  }
}
